import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentConfiguration } from '../environment/services/environment.configuration';
import { BusinessEntityService } from './business-entity.service';

@Injectable({
  providedIn: 'root'
})
export class ManagementService {
  apiBaseUrl = 'http://localhost:3000';
  apiVersion = 'api/v1';
  serviceUrl = this.apiBaseUrl;
  contentType =  'application/json' // Sonar fix
  
  // constructor(private readonly http:HttpClient) {
  constructor(private readonly http:HttpClient,private readonly environment: EnvironmentConfiguration,private readonly bservice: BusinessEntityService) {
    this.apiBaseUrl = this.environment['apiUrl']?.suppliermanagUrl;
    this.serviceUrl = this.apiBaseUrl;
  }
  
  public updateMainData(body): Observable<any> {
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType
      })
    } 
    const url = `${this.serviceUrl+this.apiVersion}/unionData`;
    return this.http.put<any>(url, body, header);
  }

  public updateReportData(body): Observable<any> {
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType
      })
    } 
    const url = `${this.serviceUrl+this.apiVersion}/update/reportsData`;
    return this.http.put<any>(url, body, header);
  }
}
